import React, { Suspense, lazy, useEffect, useState } from 'react';

// Lazy load the heavy Copilot component - only loads when user scrolls or after initial render
const AICarlyCopilot = lazy(() => 
  import('./AICarlyCopilot').then(m => ({ default: m.AICarlyCopilot }))
);

/**
 * LazyCopilot - Defers loading of the AI Copilot modal until after initial page render.
 * This removes the heavy Copilot bundle from the critical path.
 */
export const LazyCopilot: React.FC = () => {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Delay loading until after initial paint and idle time
    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(() => setShouldLoad(true), { timeout: 2000 });
      return () => cancelIdleCallback(id);
    } else {
      // Fallback for browsers without requestIdleCallback
      const timer = setTimeout(() => setShouldLoad(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  if (!shouldLoad) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <AICarlyCopilot />
    </Suspense>
  );
};

export default LazyCopilot;
